import { NavLink, useNavigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth';
import './CustomerShell.css';

interface Props {
  children: ReactNode;
}

const NAV_LINKS = [
  { path: '/', label: 'Overview' },
  { path: '/licenses', label: 'Licenses' },
  { path: '/devices', label: 'Devices' },
  { path: '/account', label: 'Account' }
];

export function CustomerShell({ children }: Props) {
  const { account, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="customer-shell">
      <header className="customer-shell__header surface">
        <div>
          <div className="customer-shell__brand">VMGate Customer Portal</div>
          <div className="text-muted" style={{ fontSize: '0.9rem' }}>
            Welcome {account?.email ?? ''}
          </div>
        </div>
        <button className="customer-shell__logout" type="button" onClick={handleLogout}>
          Sign out
        </button>
      </header>

      <nav className="customer-shell__nav surface">
        {NAV_LINKS.map((link) => (
          <NavLink key={link.path} to={link.path} end className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
            {link.label}
          </NavLink>
        ))}
      </nav>

      <main className="customer-shell__main">{children}</main>
    </div>
  );
}

